<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-读书会-添加
    -->
    <el-dialog
    title="添加读书会"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
      <div class="common-form">添加读书会</div>

      <el-form-item label="读书会名称" prop="name"><el-input v-model="form.name" placeholder="请输入读书会名称" class="max-w460"></el-input></el-form-item>
    
      <el-form-item label="读书会bannar：" prop="model.image">
      <div class="draggable-list">
        <draggable class="wrapper" v-model="form.bannar">
          <transition-group>
            <div v-for="(item, index) in form.bannar" :key="item.file_path">
              <div class="item">
                <img v-img-url="item.file_path" alt="file_path"/>
                <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index,'bannar')"><i class="el-icon-close"></i></a>
              </div>
            </div>
          </transition-group>
        </draggable>
        <div class="item img-select" @click="openProductUpload('bannar')">
          <i class="el-icon-plus"></i>
        </div>
      </div>
    </el-form-item>

<!-- 活动介绍 -->
<el-form-item label="亮点" prop="intro">
  <el-input v-model="form.intro" type="textarea" placeholder="请输入亮点" class="max-w460"></el-input>
</el-form-item>

<!-- 活动时间 -->
<!-- <el-form-item label="活动时间" prop="release_time">
  <el-date-picker 
    v-model="form.release_time" 
    type="date" 
    placeholder="请选择活动时间" 
    class="max-w460"
    value-format="yyyy-MM-dd"
    @change="handleDateChange">
  </el-date-picker>
</el-form-item> -->
<!-- 活动时间 -->
<el-form-item label="活动开始时间" prop="start_date">
  <el-date-picker 
    v-model="form.start_date" 
    type="date" 
    placeholder="请选择活动开始时间" 
    class="max-w460"
    value-format="yyyy-MM-dd"
    @change="handleDateChange">
  </el-date-picker>
</el-form-item>
<!-- 活动时间 -->
<el-form-item label="活动结束时间" prop="end_date">
  <el-date-picker 
    v-model="form.end_date" 
    type="date" 
    placeholder="请选择结束时间" 
    class="max-w460"
    value-format="yyyy-MM-dd"
    @change="handleDateChange">
  </el-date-picker>
</el-form-item>

<!-- 活动地点 -->
<el-form-item label="活动地点" prop="place">
  <el-input v-model="form.place" placeholder="请输入活动地点" class="max-w460"></el-input>
</el-form-item>

<!-- 活动简介 -->
<el-form-item label="活动介绍" prop="ac_intro">
  <el-input v-model="form.ac_intro" type="textarea" placeholder="请输入活动简介" class="max-w460"></el-input>
</el-form-item>

<!-- 主讲人姓名 -->
<el-form-item label="主讲人姓名" prop="speaker_name">
  <el-input v-model="form.speaker_name" placeholder="请输入主讲人姓名" class="max-w460"></el-input>
</el-form-item>

<!-- 主讲人介绍 -->
<el-form-item label="主讲人介绍" prop="speaker_intro">
  <el-input v-model="form.speaker_intro" type="textarea" placeholder="请输入主讲人介绍" class="max-w460"></el-input>
</el-form-item>

<!-- 最大参与人数 -->
<el-form-item label="最大参与人数" prop="maxnum">
  <el-input-number v-model="form.maxnum" :min="1" placeholder="请输入最大参与人数" class="max-w460"></el-input-number>
</el-form-item>

<!-- 费用 -->
<el-form-item label="费用" prop="cost">
  <el-input v-model="form.cost" placeholder="请输入费用（0表示免费）" class="max-w460">
    <template slot="append">元</template>
  </el-input>
</el-form-item>

<!-- 活动规则 -->
<el-form-item label="活动规则" prop="rule">
  <el-input v-model="form.rule" type="textarea" placeholder="请输入活动规则" class="max-w460"></el-input>
</el-form-item>

<el-form-item label="坐标">
  <el-row class="mb16">
    <el-col :span="24">
      <el-input v-model="form.coordinate" placeholder="经度,纬度" class="max-w460"></el-input>
    </el-col>
  </el-row>
  <el-row class="mb16">
    <el-col :span="24">
      <Getpoint :form="form" @getMapdata="getMapdataFunc" @chose="choseFunc"></Getpoint>
    </el-col>
  </el-row>
</el-form-item>

<!-- 温馨提示 -->
<el-form-item label="温馨提示" prop="tips">
  <el-input v-model="form.tips" type="textarea" placeholder="请输入温馨提示" class="max-w460"></el-input>
</el-form-item>
    

      <el-form-item label="排序" prop="sort">
        <el-input v-model="form.sort" placeholder="请输入排序" class="max-w460"></el-input>
      </el-form-item>
       
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
    
    <!--商品图片组件-->
    <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片</Upload>
  </div>
</el-dialog>
  
</template>

<script>
import AfuncApi from '@/api/afunc.js';
import Upload from '@/components/file/Upload';
import draggable from "vuedraggable";
import Getpoint from '@/components/map/Getpoint.vue';

export default {
  components: {
    Upload: Upload,
    draggable,
    Getpoint
  },
  data() {
    return {
      // 表单数据
      form: {
        name: '',
        code: 'custom',
        image: [],
        bannar: [],
        
        // release_time: '',
        start_date: '',  
        end_date: '',        
        place: '',
        ac_intro: '',
        speaker_name: '',
        speaker_intro: '',
        maxnum: 0,            
        cost: 0,              
        rule: '',
        longitude: '',        
        latitude: '',         
        coordinate: '',
        tips: '',
        
        sort: 50,             
        intro: ""
      },
      
      loading: false,
      dialogVisible: false,
      isProductUpload: false,
      code: "album",
      
      // 验证规则
      rules: {
        name: [{ required: true, message: '请输入读书会名称', trigger: 'blur' }],
        cost: [
          { pattern: /^\d+(\.\d{1,2})?$/, message: '请输入正确的金额格式', trigger: 'blur' }
        ]
      }
    };
  },
  created() {
    this.dialogVisible = this.open_add;
  },
  props: ["open_add"],
  methods: {
    getMapdataFunc(e) {
      this.form.coordinate = e.data[0].toFixed(6) + ',' + e.data[1].toFixed(6);
      this.form.longitude = e.data[0].toFixed(6);
      this.form.latitude = e.data[1].toFixed(6);
    },

    choseFunc(e) {
      this.form.coordinate = e.location.lat + ',' + e.location.lng;
      this.form.longitude = e.location.lat;
      this.form.latitude = e.location.lng;
      console.log('地图选择返回数据:', e);
      if (e.ad_info && e.ad_info.adcode) {
        let adcode = String(e.ad_info.adcode);
        console.log('adcode:', adcode, '长度:', adcode.length);
        if (adcode.length === 6) {
          this.form.cityCode = adcode + '000000';
        } else {
          this.form.cityCode = adcode;
        }
      }
    },

    handleDateChange(value) {
      console.log('日期选择变化:', value);
      // 这里可以添加额外的日期处理逻辑
    },
    
    // 关闭弹窗
    dialogFormVisible(result) {
      this.$emit("close", { openDialog: false, "type": "" });
    },
    
    // 提交表单
    async onSubmit() {
      let self = this;
      
      // 验证表单
      self.$refs.form.validate(async valid => {
        if (!valid) {
          self.$message({
            message: '请填写完整的表单信息',
            type: 'warning'
          });
          return;
        }
        
        // 复制表单数据，避免修改原始数据
        let submitData = {...self.form};
        
        // ========== 数据处理部分 ==========
        // 1. 格式化费用为数字
        if (submitData.cost) {
          submitData.cost = parseFloat(submitData.cost) || 0;
        }
        
  
  
        // 5. 确保最大参与人数为数字
        if (submitData.maxnum) {
          submitData.maxnum = parseInt(submitData.maxnum) || 0;
        }
        
        console.log('提交的数据:', submitData);
        
        // 提交数据
        self.loading = true;

          const response = await AfuncApi.call({
          model: 'reading',
          action: 'add',
          ...submitData
        });
        
        if (response.code === 1) {
          this.$message.success(response.msg || '添加成功');
          this.dialogFormVisible("success");
        } else {
          this.$message.error(response.msg || '添加失败');
        }
      });
    },
    
    // 取消添加
    cancelFunc() {
      this.$emit("close", { openDialog: false, "type": "" });
    },
    
    // 打开上传图片
    openProductUpload: function (code) {
      this.isProductUpload = true;
      this.code = code;
    },
    
    // 上传商品图片回调
    returnProductImgsFunc(e) {
      if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        
        // 验证图片格式
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1].toLowerCase();
          if (imgExpt.includes(ext)) {
            prevent = true;
          }
        });
        
        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }
        
        // 根据类型添加到对应的数组
        if (this.code == 'album') {
          let imgs = this.form.image.concat(e);
          this.$set(this.form, "image", imgs);
        } else if (this.code == 'bannar') {
          let imgs = this.form.bannar.concat(e);
          this.$set(this.form, "bannar", imgs);
        }
      }
      
      this.isProductUpload = false;
    },
    
    // 删除图片
    deleteImg(index, code) {
      if (code == 'album') {
        this.form.image.splice(index, 1);
      } else if (code == 'bannar') {
        this.form.bannar.splice(index, 1);
      }
    }
  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}

.mb16 {
  margin-bottom: 16px;
}

.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>


// WEBPACK FOOTER //
// src/views/plus/reading/index/part/add.vue